import { MessageCircle } from "lucide-react"

const NUMBERS = ["+256 766 553 449", "+256 701 511 262"]
const TEXT = encodeURIComponent("Hello Jero-One Technologies, I'd like to ask about ")

export function WhatsAppButtons({ className = "" }) {
  return (
    <div className={`flex flex-wrap gap-3 ${className}`} data-testid="whatsapp-buttons">
      {NUMBERS.map((n) => (
        <a
          key={n}
          href={`https://wa.me/${n.replace(/\D/g, "")}?text=${TEXT}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`whatsapp-btn-${n.slice(-3)}`}
          className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-2 text-xs font-bold text-[#0A0F0B] transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#2fe076]"
        >
          <MessageCircle className="h-4 w-4" />
          WhatsApp {n}
        </a>
      ))}
    </div>
  )
}
